import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

import { EnvironmentService, UaService } from '@ecm/consumer';
import { ContextService } from '@ecm/portfolio';
import { RouterService } from '@ecm/router';
import { TMSService } from '@ecm/tracker';

import { SmartbannerStoreService } from '../../store/smartbanner-store.service';
import { SmartbannerTmsKey } from './smartbanner-tms-key';

const faviconPathOrangeEtMoi = '/assets/images/favicon/oem_fr.svg';
const faviconPathMySosh = '/assets/images/favicon/mysosh_fr.svg';

@Component({
    selector: 'ecm-smartbanner',
    templateUrl: './smartbanner.component.html',
    styleUrls: ['./smartbanner.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [TranslateModule],
})
export class SmartbannerComponent implements OnInit {
    public smartBannerBrand: string | undefined;
    public smartBannerImg: string | undefined;
    public smartBannerUrl = '';

    private trackZone = '';

    public constructor(
        protected routerService: RouterService,
        protected uaService: UaService,
        private environmentService: EnvironmentService,
        private smartBannerStore: SmartbannerStoreService,
        private tmsService: TMSService,
        private readonly contextService: ContextService,
    ) {}

    public ngOnInit(): void {
        /* UC we need to detect the brand to display smartbanner in correct ui*/
        this.contextService.isSosh().subscribe((isSosh) => {
            this.smartBannerBrand = isSosh ? 'My Sosh' : 'Orange et moi';
            this.smartBannerImg = isSosh ? faviconPathMySosh : faviconPathOrangeEtMoi;
            this.smartBannerUrl = this.environmentService.instant(
                `API.SMARTBANNER.URL_${isSosh ? 'SOSH' : 'OEM'}_${
                    this.uaService.getOSName() === 'iOS' ? 'IOS' : 'ANDROID'
                }`,
            );
            this.trackZone = isSosh ? 'smart_banner_mysosh' : 'smart_banner_orangeetmoi';
            const data: any = {
                track_zone: this.trackZone,
                track_nom: SmartbannerTmsKey.VW_SMARTBANNER,
                track_cible: SmartbannerTmsKey.VW_SMARTBANNER,
                flag_acte: 'true',
                id_tracking: isSosh ? 'RMReEPbH' : 'tcONY3kp',
            };
            this.tmsService.trackView(data);
        });
    }

    public close(): void {
        const data: any = {
            track_zone: this.trackZone,
            track_nom: SmartbannerTmsKey.LK_SMARTBANNER_CLOSED,
            track_cible: '/'.concat(SmartbannerTmsKey.LK_SMARTBANNER_CLOSED),
        };
        this.tmsService.trackLink(data);
        this.smartBannerStore.close();
    }

    public navigateToApp(): void {
        const data: any = {
            track_zone: this.trackZone,
            track_nom: SmartbannerTmsKey.LK_SMARTBANNER_OPEN,
            track_cible: '/'.concat(SmartbannerTmsKey.LK_SMARTBANNER_OPEN),
        };
        this.tmsService.trackLink(data);
        this.smartBannerStore.navigateToApp(this.smartBannerUrl);
    }
}
